export class IngestionPipelineLastObservation {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "observedAt",
            "baseName": "observedAt",
            "type": "Date",
            "format": "date-time"
        },
        {
            "name": "observedStatus",
            "baseName": "observedStatus",
            "type": "string",
            "format": ""
        },
        {
            "name": "health",
            "baseName": "health",
            "type": "IngestionPipelineLastObservationHealthEnum",
            "format": ""
        },
        {
            "name": "flinkDeployment",
            "baseName": "flinkDeployment",
            "type": "IngestionPipelineObservationFlinkDeployment",
            "format": ""
        },
        {
            "name": "pods",
            "baseName": "pods",
            "type": "Array<PodObservation>",
            "format": ""
        },
        {
            "name": "recentWarningEvents",
            "baseName": "recentWarningEvents",
            "type": "Array<K8sEventObservation>",
            "format": ""
        },
        {
            "name": "issues",
            "baseName": "issues",
            "type": "Array<IngestionPipelineIssue>",
            "format": ""
        },
        {
            "name": "issuesStale",
            "baseName": "issuesStale",
            "type": "boolean",
            "format": ""
        },
        {
            "name": "observeError",
            "baseName": "observeError",
            "type": "string",
            "format": ""
        },
        {
            "name": "tableFormatVersion",
            "baseName": "tableFormatVersion",
            "type": "number",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return IngestionPipelineLastObservation.attributeTypeMap;
    }
    constructor() {
    }
}
export var IngestionPipelineLastObservationHealthEnum;
(function (IngestionPipelineLastObservationHealthEnum) {
    IngestionPipelineLastObservationHealthEnum["Healthy"] = "HEALTHY";
    IngestionPipelineLastObservationHealthEnum["Starting"] = "STARTING";
    IngestionPipelineLastObservationHealthEnum["Suspended"] = "SUSPENDED";
    IngestionPipelineLastObservationHealthEnum["Degraded"] = "DEGRADED";
    IngestionPipelineLastObservationHealthEnum["Unhealthy"] = "UNHEALTHY";
    IngestionPipelineLastObservationHealthEnum["Missing"] = "MISSING";
    IngestionPipelineLastObservationHealthEnum["Unknown"] = "UNKNOWN";
})(IngestionPipelineLastObservationHealthEnum || (IngestionPipelineLastObservationHealthEnum = {}));
